<template>
  <view class="packet" wx:style="{{style}}">
    <view class="sign-in">
      <view class="sign-activity {{ discountObj.point && 'has-point' }}">周五 六 日低至<text class="cash"><text class="integer">{{ discountObj.integer }}</text><text class="point">{{ discountObj.point }}</text><text class="decimal">{{ discountObj.decimal }}</text></text>折</view>
      <view wx:for="{{signList}}" wx:key="index" class="sign-item {{ index >= 4 && 'is-activity' }}" bindtap="switchCoupon(index)">
        <block wx:if="{{ index < 4 }}">
          <view class="sign-day">{{ item.text }}</view>
          <view class="sign-bonus">
            <image webp src="{{ item.is_sign_in ? bonusImg.sign : bonusImg.common }}" mode="widthFix" class="bonus-img" />
          </view>
        </block>
        <block wx:else>
          <view class="sign-bonus">
            <image webp src="{{ item.is_sign_in ? activityBonusImg.sign : activityBonusImg.common }}" mode="widthFix" class="bonus-img" />
          </view>
          <view wx:if="{{ index === 6 }}" class="final-bonus">签到大奖</view>
        </block>
        <view wx:if="{{ item.couponIsToday }}" class="icon-arrow"></view>
      </view>
    </view>
    <view class="coupon-warp {{ !showReward && 'is-reward' }}">
      <view wx:if="{{ !(couponList && couponList.length) || !couponIsToday }}" class="coupon" wx:style="{{couponStyle}}">
        <block wx:if="{{ couponInfo }}">
          <view class="tip">{{ couponTypeTip }}</view>
          <view class="info">
            <text class="cash">{{ couponInfo.max_benefit_capacity.value }}</text><text>{{ couponInfo.max_benefit_capacity.unit }}</text>打车券包
          </view>
          <view class="desc">
            <block wx:if="{{showBonus}}">
              <image class="bonus-icon" src="https://ut-static.udache.com/webx/ut/OClMcUjGzWfbq6zx7XIBu.png" />
              <text class="bonus-cash">{{ todayInfo.count }}</text>
            </block>
            {{ todayInfo.desc }}
            <image wx:if="{{ todayInfo.is_today && todayInfo.is_sign_in }}" bindtap="toBonusRule" class="tip-icon" src="https://ut-static.udache.com/webx/ut/O31m-kg4Vnn6jq7QlD-t6.png" mode="widthFix" />
            <view wx:if="{{ todayInfo.max_count }}" class="max-bonus"> 最高{{ todayInfo.max_count }} </view>
          </view>
        </block>
      </view>
      <view wx:else class="reward-list">
        <view wx:for="{{couponList_real}}" wx:key="index" class="reward-item">
          <view class="coupon-type">{{ item.typeName }}</view>
          <view><text class="cash">{{ item.coupon.max_benefit_capacity.value }}</text><text class="unit">{{ item.coupon.max_benefit_capacity.unit }}</text></view>
          <view class="reward-info">
            <view class="usage-limit">{{ item.coupon.usage_limit }}</view>
            <view class="valid-period">{{ item.coupon.remark || item.coupon.name }}</view>
          </view>
        </view>
      </view>
    </view>
    <button class="btn {{ !couponIsToday && 'is-disable' }}" bindtap="click">{{ buttonText }}</button>
  </view>
</template>

<script>
import mpx, { createComponent } from '@mpxjs/core'
import { formatValue, getCouponTypeTip } from '../../lib/utils'
import { getStyle } from '../../lib/editor/utils'
import { goTo, utils, trackEvent } from '@didi/webx-js'
import store from '../../lib/store'

createComponent({
  properties: {
    config: Object,
    btnText: String,
    couponList: Array,
  },
  data: {
    bonusImg: {
      common: utils.webpUrl('https://ut-static.udache.com/webx/ut/I6XqkbtzXiOebxtxio-Zw.png', { isImageTag: true }),
      sign: utils.webpUrl('https://ut-static.udache.com/webx/ut/ovM5lHKL-xWdsMASOVtt2.png', { isImageTag: true }),
    },
    activityBonusImg: {
      common: utils.webpUrl('https://ut-static.udache.com/webx/ut/AT8AdYCs-bX_iWhOPML--.png', { isImageTag: true }),
      sign: utils.webpUrl('https://ut-static.udache.com/webx/ut/bmH4CfT1VtFGjiLH59Gii.png', { isImageTag: true }),
    },
  },
  watch: {
    couponList(val) {
      val && val.length && trackEvent('userteam_ddlm_couponlist_pg_sw', '展现')
    },
  },
  computed: {
    ...store.mapGetters([ 'initData' ]),
    couponList_real() {
      return this.couponList.map(item => {
        item.typeName = getCouponTypeTip(item.coupon.type)
        return item
      })
    },
    buttonText() {
      return this.couponIsToday ? this.btnText : `${this.signList[this.initData.sign_in_week - 1].text}可领`
    },
    couponInfo() {
      return this.initData.activity_info?.rewards?.[0]?.coupon
    },
    couponTypeTip() {
      const map = {
        1: '最高',
        2: '最高',
        100: '低至',
      }
      return map[this.couponInfo.type]
    },
    discountObj() {
      return formatValue(this.config.couponDiscount)
    },
    style() {
      return getStyle(this.config?.style)
    },
    couponStyle() {
      return getStyle(this.config.coupon.style)
    },
    todayInfo() {
      return this.signList.filter((item, index) => this.initData.sign_in_week !== undefined ? index + 1 === this.initData.sign_in_week : item.is_today)[0]
    },
    showReward() {
      return !(this.couponList && this.couponList.length) || !this.couponIsToday
    },
    signList() {
      const num2chinese = [ '一', '二', '三' , '四', '五', '六' , '日' ]
      return this.initData.sign_in_infos.map((item, index) => {
        item.text = '周' + num2chinese[index]
        item.couponIsToday = this.initData.sign_in_week === undefined ? item.is_today : this.initData.sign_in_week === index + 1
        return item
      })
    },
    couponIsToday() {
      if (this.initData.sign_in_week === undefined) {
        return true
      }
      return this.signList[this.initData.sign_in_week - 1].is_today
    },
    showBonus() {
      if (this.initData.sign_in_week === 7 || this.signList[6].is_today) {
        return false
      }
      if (this.couponIsToday) {
        return !this.todayInfo.is_sign_in 
      } else {
        return true
      }
    },
  },
  methods: {
    ...store.mapActions([ 'getInitData' ]),
    async switchCoupon(index) {
      mpx.showLoading({
        mask: true,
      })
      await this.getInitData({ week: (index + 1) % 7 })
      mpx.hideLoading()
    },
    click(e) {
      if (!this.couponIsToday) {
        return
      }
      this.triggerEvent('click', e.detail)
    },
    toBonusRule() {
      goTo({ url: this.config.bonusRuleLink })
    },
  },
})
</script>

<style lang="stylus" scoped>
  .packet
    width 750rpx
    height 980rpx
    padding-top 356rpx
    box-sizing border-box
    overflow hidden
    position relative
    .coupon-warp
      background-image: linear-gradient(0deg, #FEFAF3 2%, #FEEFDE 99%);
      border-radius: 30rpx;
      margin 30rpx auto 0
      width: 630rpx;
      height: 280rpx;
      &.is-reward
        margin 30rpx 60rpx 0
    .coupon, .reward-list
      position relative
      background-size cover
      box-sizing: border-box;
    .reward-list
      display flex
      // margin 30rpx 60rpx 0
      overflow-x: auto;
      padding 24rpx 0 14rpx
      .reward-item
        flex-shrink: 0;
        width 182rpx
        height 232rpx
        margin-left 8rpx
        background url(https://ut-static.udache.com/webx/ut/pMSkgQI2_I-jmvVG7idDY.png) center/cover no-repeat
        padding-top 28rpx
        text-align center
        box-sizing: border-box;
        position relative
        &:first-child
          margin-left 13rpx
        &:last-child
          margin-right 13rpx
        .coupon-type
          position absolute
          top 0
          left 0
          right 0
          font-family: PingFangSC-Semibold;
          font-size: 18rpx;
          color: #FDF6E1;
          font-weight: 600;
        .cash
          font-family: DIN-BlackItalic, DIN-BlackItalic-self;
          font-size: 70rpx;
          color: #F3443E;
          position relative
          bottom -4rpx
        .unit
          font-family: MF-YuanHei-Regular, MF-YuanHei-Regular-self;
          font-size: 28rpx;
          color: #F3443E;
        .usage-limit
          margin-bottom 8rpx
        .usage-limit, .valid-period
          font-family: PingFangSC-Medium;
          font-size: 18rpx;
          color: #AF5902;
          font-weight: 500;
          line-height 1
        .valid-period
          font-size: 16rpx;
        .reward-info
          position absolute
          left 0
          right 0
          bottom 0
          height 98rpx
          padding 0 8rpx
          display: flex;
          flex-direction: column;
          justify-content: center;
          box-sizing border-box
          padding-bottom 4rpx
    .coupon
      // margin 30rpx auto 0
      font-family: MF-YuanHei-Regular, MF-YuanHei-Regular-self;
      font-size: 40rpx;
      color: #F3443E;
      letter-spacing: 1.82rpx;
      font-weight: 400;
      text-align center
      width 100%
      height 100%
      .tip
        box-sizing: border-box
        width: 58rpx;
        height: 28rpx;
        background: #FF4D47;
        border: 1px solid rgba(255,237,210,1);
        border-radius: 10rpx;
        text-align center
        line-height 28rpx
        position absolute
        right 64rpx
        top 71rpx
        font-family: PingFangSC-Semibold;
        font-size: 16rpx;
        color: #FFF7EC;
        font-weight: 600;
      .info
        position absolute
        top 54rpx
        left 0
        right 0
        .cash
          font-family: UniSansHeavyCapsItalic, UniSansHeavyCapsItalic-self;
          font-size: 80rpx;
          color: #F3443E;
          letter-spacing: 0;
          line-height: 1;
          position relative
          bottom -8rpx
          padding-right 5rpx
      .max-bonus
        height: 24rpx;
        background: #FF631E;
        border-radius: 15rpx 15rpx 15rpx 0
        font-family: AlibabaPuHuiTi-Regular;
        font-size: 16rpx;
        color: #FFFFFF;
        letter-spacing: 0;
        text-align: center;
        font-weight: 400;;
        line-height 24rpx
        padding 0 6rpx
        margin-left 10rpx
      .desc
        position absolute
        top 164rpx
        left 0
        right 0
        font-family: PingFangSC-Semibold;
        font-size: 18rpx;
        color: #AF5902;
        text-align: center;
        font-weight: 600;
        display flex
        align-items center
        justify-content: center;
        .bonus-icon
          width 20rpx
          height 20rpx
          margin-right 4rpx
        .bonus-cash
          font-family: UniSansHeavyCapsItalic, UniSansHeavyCapsItalic-self;;
          font-size: 24rpx;
          color: #FF631E;
          font-weight: 900;
          margin-right 10rpx
        .tip-icon
          width 19rpx
          margin-left 10rpx
    .btn
      margin 12rpx auto 53rpx
      width: 530rpx;
      height: 110rpx;
      background: #FF5000;
      background-image: linear-gradient(219deg, #FF6B00 0%, #FF5000 77%);
      border-radius: 55rpx;
      line-height 110rpx
      text-align center
      font-family: MF-YuanHei-Regular, MF-YuanHei-Regular-self;
      font-size: 56rpx;
      color: #FFF6E8;
      letter-spacing: 2rpx;
      text-shadow: 0 1px 0 rgba(255,240,213,0.70);
      font-weight: 400;
      &.is-disable
        background: #FF5000;
        background-image: linear-gradient(219deg, #BBB9B9 0%, #9F9F9F 77%);
        color: #FFFFFF;
    .sign-in
      padding 0 65rpx
      display flex
      align-items flex-end
      position relative
      .sign-activity
        box-sizing: border-box;
        position absolute
        right 35rpx
        // top -55rpx
        bottom: 98rpx;
        font-family: AlibabaPuHuiTi-Heavy, AlibabaPuHuiTi-Heavy-self;
        font-size: 26rpx;
        color: #FFFFFF;
        padding 0 28rpx 0 0
        display: flex;
        align-items: baseline;
        &.has-point
          bottom: 102rpx;
          padding 0 18rpx 0 0
          .cash
            position relative
            top 2rpx
            font-size: 35rpx;
            padding 0 2rpx 0 2rpx
            .integer
              font-size: 62rpx;
              position relative
              top 2rpx
        .cash
          font-family: DIN-BlackItalic, DIN-BlackItalic-self;
          font-size: 80rpx;
          color: #FFFFFF;
          font-weight: 400;
          position relative
          bottom -6rpx
          padding 0 4rpx
          .integer
            -webkit-text-stroke: 1px rgba(253,87,52,1);
      .sign-item
        box-sizing: border-box;
        padding 9rpx 0 10rpx
        width: 80rpx;
        height: 140rpx;
        background-image: linear-gradient(180deg, #FFF1EE 13%, #FFE0D9 98%);
        border-radius: 20rpx;
        margin-right 10rpx
        text-align center
        position relative
        .sign-day
          font-family: AlibabaPuHuiTi-Medium;
          font-size: 24rpx;
          color: #BC6908;
          letter-spacing: 0;
          font-weight: 500;
          margin-bottom 13rpx
        &.is-activity
          height: 80rpx;
          border-radius: 27.3rpx;
          padding-top 0
          background-image: linear-gradient(180deg, #FFF5F2 13%, #FFE0D9 98%);
          .sign-bonus
            margin-top: -6rpx;
        &:last-child
          margin-right 0
        .sign-bonus
          width 80rpx
          height 75rpx
          .bonus-img
            width 100%
        .final-bonus
          width: 92rpx;
          height: 28rpx;
          background url(https://ut-static.udache.com/webx/ut/lq5QgNGmLEHsQmkHGwxwm.png) center/cover no-repeat
          font-family: AlibabaPuHuiTi-Bold;
          font-size: 16rpx;
          color: #FFFFFF;
          letter-spacing: 0;
          text-align: center;
          font-weight: 800;
          position absolute
          bottom 0
          left: 0
          right: 0
          line-height 28rpx
        .icon-arrow
          position absolute
          bottom -46rpx
          left 50%
          width: 30rpx;
          height: 30rpx;
          background-image: linear-gradient(45deg, #FFE4DD 12%, #FEF0DE 50%, transparent 50%, transparent 100%)
          transform translateX(-50%) rotate(135deg)
          // background-image: linear-gradient(0deg, #FEFAF3 2%, #FFECD4 99%);
          border-bottom-left-radius 4rpx
</style>

<script type="application/json" lang="json">
{
  "component": true,
  "usingComponents": {}
}
</script>

